export default __webpack_public_path__ + "static/media/nexus-mark.a562ae52.svg";